function isValidURL(url: string) {
  const urlRegex = /^(https?|ftp):\/\/(-\.)?([^\s\/?\.#-]+\.?)+(\/[^\s]*)?$/i

  return urlRegex.test(url)
}

export default isValidURL
